export enum CommunicationService {
  A = 'backend-1',
  B = 'backend-2',
  C = 'backend-3',
  Userlike = 'userlike',
}

export type ChatBackend = Exclude<
  CommunicationService,
  CommunicationService.Userlike
>
